import { Component } from '@angular/core';
import { ParameterGroup } from '../../../models/parameter-group';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { findParameterGroupAct } from '../../../store/parameters/parameters.actions';

@Component({
  selector: 'app-parameters-view',
  standalone: false,
  templateUrl: './parameters-view.component.html',
  styleUrl: './parameters-view.component.css'
})
export class ParametersViewComponent {

  parameterGroup: ParameterGroup = new ParameterGroup();
  loading: boolean = false;

  columndefs : any[] = ['id','objectAttributeName', 'objectAttributeAttribute','inOut','formula',//'objectAttributeObjectClassRouteClass',
    'objectAttributeObjectClassObject','objectAttributeObjectTypeComments'];


  ngOnInit(): void {
    //this.holidaysGroupStore.dispatch(resetHolidayGroupAct());
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.parameterGroupStore.dispatch(findParameterGroupAct({ id }));
      }else{
        /*this.holidayGroup = new HolidayGroup();
        this.holidayGroup.active = true;
        this.loading = false;*/

      }
    });
  }

  constructor(
    private parameterGroupStore: Store<{parameterGroupRdc: any}>,
    private route: ActivatedRoute,
  ){

    this.parameterGroupStore.pipe(
      
      select('parameterGroupRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        parameterGroup: state.parameterGroup,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ parameterGroup, loading }) => {
      this.parameterGroup = JSON.parse(JSON.stringify(parameterGroup));
      this.loading = loading;

    });

  }

}
